export default __webpack_public_path__ + "static/sam42_management-4574bc370354e507686db1813e29f477.jpg";